export const LOADING = 'USER/LOADING';
export const LOADED = 'USER/LOADED';
export const LOGOUT = 'USER/LOGOUT';
export const LOGIN = 'USER/LOGIN';
export const SET_CUSTOMER = 'USER/SET_CUSTOMER';
export const SET_LANGUAGE_REQUEST = 'SET_LANGUAGE_REQUEST';
export const SET_LANGUAGE_SUCCESS = 'SET_LANGUAGE_SUCCESS';
export const SET_LANGUAGE_FAIL = 'SET_LANGUAGE_FAIL';
